import { gql } from '@apollo/client';

import { StudentAnsweredAssignment } from '@ts-core/modules/assignments/types';
import { studentAnsweredAssignmentFragment } from '@ts-core/modules/assignments/graphql/fragments';

export interface GetAssignmentDetailsQueryVariables {
  courseId: string;
  assignmentId: string;
}

export interface GetAssignmentDetailsQueryResult {
  assignment: StudentAnsweredAssignment;
}

export const getAssignmentDetailsQuery = gql`
  query GetAssignmentDetailsQuery($courseId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId)
      @rest(type: "StudentAnsweredAssignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}") {
      ...StudentAnsweredAssignment
    }
  }
  ${studentAnsweredAssignmentFragment}
`;
